import { makeStyles } from "@mui/styles";

const toggleButtonStyle = makeStyles((theme) => ({

    toggleContainer: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#ebebeb",
        borderRadius: "20px",
        width: "300px",
        height: "40px",
        cursor: "pointer",
        marginBottom: "1rem",
        marginLeft: 'auto',
        [theme.breakpoints.down("sm")]: {
            margin: "0 auto",
            display: "flex",
            justifyContent: "center",
            height: "50px",
        },
    },

    toggleOption: {
        flex: 1,
        textAlign: "center",
        lineHeight: "40px",
        fontWeight: "bold",
        fontSize: "1rem",
        color: theme.palette.text.third,
        zIndex: 2,
        userSelect: "none",
        transition: "color 0.3s ease",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.2rem",
        },
    },

    activeText: {
        color: theme.palette.text.primary,
    },

    switcher: {
        position: "absolute",
        backgroundColor: "#fff",
        borderRadius: "25px",
        width: "140px",
        height: "32px",
        top: "4px",
        zIndex: 1,
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
        transition: "all 0.8s ease-in-out",
        [theme.breakpoints.down("sm")]: {
            height: "42px",
        },
    },

    switcherLeft: {
        transform: "translateX(10px)",
        [theme.breakpoints.down("sm")]: {
            transform: "translateX(-70px)",
        },
    },

    switcherRight: {
        transform: "translateX(150px)",
        [theme.breakpoints.down("sm")]: {
            transform: "translateX(70px)",
        },
    },

}));

export default toggleButtonStyle;